import styled from 'styled-components';

export const Content = styled.div`
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.background};

  .socialMedias {
    display: flex;
    margin-top: 1rem;
    gap: 0.5rem;

    button {
      background: ${({ theme }) => theme.colors.yellow_200};
    }
  }
`;
